export default class {
  constructor(element) {
    this.element = element
    this.headerFixed = false
    window.addEventListener('scroll', this.scrollChanged.bind(this))
    this.scrollChanged()

    // Darkens body background on menu toggle.
    const navItems = document.querySelectorAll('.navigation.-main .nav-item')
    if (navItems.length && window.innerWidth >= 1025) {
      navItems.forEach((navItem) => {
        ;['mouseenter', 'mouseleave', 'focusin', 'focusout'].forEach(
          (eventType) => {
            navItem.addEventListener(eventType, () =>
              this.toggleMenuClass(eventType),
            )
          },
        )
      })
    }
  }

  toggleMenuClass(eventType) {
    const method =
      eventType.includes('enter') || eventType.includes('focusin')
        ? 'add'
        : 'remove'
    document.body.classList[method]('-overlay')
  }

  scrollChanged() {
    if (window.scrollY > 54) {
      if (!this.headerFixed) {
        window.requestAnimationFrame(this.enableFixed.bind(this))
      }
    } else if (this.headerFixed) {
      window.requestAnimationFrame(this.disableFixed.bind(this))
    }
  }

  enableFixed() {
    this.headerFixed = true
    document.body.classList.add('header-fixed')
  }

  disableFixed() {
    this.headerFixed = false
    document.body.classList.remove('header-fixed')
  }
}
